<template>
  <!-- ES-1661: vector miniature of the Enroll Talent dashboard (owner pick "B"), no account data. -->
  <svg
    viewBox="0 0 580 330"
    aria-hidden="true"
    focusable="false"
    font-family="Inter, Helvetica, Arial, sans-serif"
  >
    <rect width="580" height="330" rx="12" fill="#FBFAFD" />
    <rect width="132" height="330" rx="12" fill="#FFFFFF" />
    <rect x="131" width="1" height="330" fill="#ECEAF1" />
    <circle
      cx="22"
      cy="22"
      r="8"
      fill="none"
      stroke="#6C38D2"
      stroke-width="3"
    />
    <text x="36" y="26" font-size="11" font-weight="700" fill="#241D3A">
      enroll
    </text>
    <rect x="10" y="38" width="112" height="16" rx="5" fill="#6C38D2" />
    <text
      x="66"
      y="49"
      font-size="7"
      font-weight="600"
      fill="#FFFFFF"
      text-anchor="middle"
    >
      {{ createJob }}
    </text>
    <g v-for="(width, index) in navWidths" :key="'nav' + index">
      <rect
        x="10"
        :y="62 + index * 20"
        width="112"
        height="17"
        rx="5"
        :fill="index === 0 ? '#F4F2F8' : 'none'"
      />
      <rect
        x="18"
        :y="66 + index * 20"
        width="9"
        height="9"
        rx="2"
        fill="none"
        stroke="#8A8594"
        stroke-width="1.2"
      />
      <rect
        x="33"
        :y="68 + index * 20"
        :width="width"
        height="5"
        rx="2.5"
        :fill="index === 0 ? '#2A2733' : '#6D6878'"
      />
    </g>

    <text x="150" y="36" font-size="13" font-weight="600" fill="#161419">
      {{ $gettext("Hello, Marie") }}
    </text>
    <text x="150" y="52" font-size="8" fill="#6D6878">
      {{ $gettext("Here's what changed on your boards this week.") }}
    </text>
    <rect x="488" y="22" width="80" height="20" rx="6" fill="#6C38D2" />
    <text
      x="528"
      y="35"
      font-size="7.5"
      font-weight="600"
      fill="#FFFFFF"
      text-anchor="middle"
    >
      {{ createJob }}
    </text>

    <g
      v-for="(kpi, index) in kpis"
      :key="'kpi' + index"
      :transform="`translate(${150 + index * 100},78)`"
    >
      <rect width="92" height="70" rx="7" fill="#FFFFFF" stroke="#EAE8EF" />
      <text x="9" y="17" font-size="8" font-weight="600" fill="#1F1D24">
        {{ kpi.label }}
      </text>
      <text x="9" y="46" font-size="17" font-weight="600" fill="#161419">
        {{ kpi.value }}
      </text>
      <path
        :d="kpi.spark"
        transform="translate(44,44)"
        fill="none"
        stroke="#9F9AA8"
        stroke-width="1.2"
      />
      <text x="9" y="61" font-size="6" fill="#77727F">
        {{ $gettext("vs 12 months") }}
      </text>
    </g>

    <rect
      x="150"
      y="160"
      width="392"
      height="160"
      rx="8"
      fill="#FFFFFF"
      stroke="#EAE8EF"
    />
    <text x="162" y="180" font-size="9" font-weight="600" fill="#161419">
      {{ $gettext("Applications overview") }}
    </text>
    <line
      v-for="row in 4"
      :key="'grid' + row"
      x1="166"
      x2="400"
      :y1="baseline - (row - 1) * 22"
      :y2="baseline - (row - 1) * 22"
      stroke="#F1EFF4"
    />
    <g v-for="bar in bars" :key="'bar' + bar.x">
      <rect :x="bar.x" :y="bar.y1" width="11" :height="bar.h1" fill="#8B5CF6" />
      <rect :x="bar.x" :y="bar.y2" width="11" :height="bar.h2" fill="#6D3FD8" />
      <rect
        :x="bar.x"
        :y="bar.y3"
        width="11"
        :height="bar.h3"
        rx="1"
        fill="#4B1FA8"
      />
    </g>
    <line x1="412" x2="412" y1="190" y2="300" stroke="#ECEAF1" />
    <g transform="translate(455,232)" fill="none" stroke-width="12">
      <circle
        v-for="source in sources"
        :key="'ring' + source.name"
        r="26"
        :stroke="source.color"
        :stroke-dasharray="`${source.dash} 164`"
        :stroke-dashoffset="source.offset"
        transform="rotate(-90)"
      />
    </g>
    <g
      v-for="(source, index) in sources"
      :key="'legend' + source.name"
      font-size="7"
      fill="#3B3843"
    >
      <circle cx="492" :cy="212 + index * 14" r="3" :fill="source.color" />
      <text x="499" :y="215 + index * 14">{{ source.name }}</text>
    </g>
  </svg>
</template>

<script>
const BASELINE = 262;
const MONTHLY_APPLICATIONS = [0, 0, 0, 0, 0, 0, 0, 0, 34, 52, 14, 1, 0];

export default {
  data() {
    return {
      baseline: BASELINE,
      navWidths: [58, 54, 62, 48, 52, 40],
      sources: [
        { name: "Indeed", color: "#6D3FD8", dash: 55, offset: 0 },
        { name: "Career", color: "#12A150", dash: 54, offset: -55 },
        { name: "LinkedIn", color: "#C0288F", dash: 44, offset: -109 },
        { name: "JobsMedia", color: "#F59E0B", dash: 4, offset: -153 }
      ]
    };
  },
  computed: {
    createJob() {
      return this.$gettext("+ Create a job");
    },
    kpis() {
      return [
        {
          label: this.$gettext("Open positions"),
          value: "55",
          spark: "M0 16 L30 16 L36 2 L40 2"
        },
        {
          label: this.$gettext("Active candidates"),
          value: "302",
          spark: "M0 16 L28 16 Q34 2 40 2"
        },
        {
          label: this.$gettext("Interviews"),
          value: "63",
          spark: "M0 16 L26 16 L30 1 L34 16 L40 16"
        },
        {
          label: this.$gettext("Pending jobs"),
          value: "17",
          spark: "M0 16 L24 16 L29 2 L34 16 L40 16"
        }
      ];
    },
    bars() {
      return MONTHLY_APPLICATIONS.map((value, month) => {
        const h1 = value * 0.45;
        const h2 = value * 0.3;
        const h3 = value * 0.25;
        return {
          value,
          x: 172 + month * 17,
          h1,
          h2,
          h3,
          y1: BASELINE - h1,
          y2: BASELINE - h1 - h2,
          y3: BASELINE - h1 - h2 - h3
        };
      }).filter(bar => bar.value > 0);
    }
  }
};
</script>
